<script setup lang="ts">
import { definePageMeta, ref } from '#imports'
import { login } from '../composables/auth'

definePageMeta({ layout: false })

const email = ref('')
const password = ref('')
const loading = ref(false)
const error = ref('')

const trylogin = async (e: Event) => {
  e.preventDefault()

  if (loading.value) return
  loading.value = true
  error.value = ''

  const response = await login(email.value, password.value)

  loading.value = false

  if (!response.status_ok) {
    error.value = response.message ?? 'Error'
  } else {
    window.location.href = '/admin/home/'
  }
}
</script>

<template>
  <div class="min-h-screen flex items-center justify-center bg-cms-dark-white px-4">
    <div class="w-full max-w-md bg-white border border-cms-input-border p-8">
      <form
        class="flex flex-col gap-4"
        @submit="trylogin"
      >
        <div class="flex flex-col gap-1">
          <label class="text-admin-input-label">Email</label>
          <input
            v-model="email"
            type="email"
            name="email"
            required
            class="input-admin-text"
          >
        </div>

        <div class="flex flex-col gap-1">
          <label class="text-admin-input-label">Password</label>
          <input
            v-model="password"
            type="password"
            name="password"
            required
            class="input-admin-text"
          >
        </div>

        <button
          type="submit"
          :disabled="loading"
          class="button-admin-blue disabled:opacity-50 disabled:cursor-not-allowed"
        >
          {{ loading ? 'Logging...' : 'Login' }}
        </button>

        <p
          v-if="error"
          class="text-sm text-red-500"
        >
          {{ error }}
        </p>
      </form>
    </div>
  </div>
</template>
